import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IUnmatchedOrderRepository } from '@/coreInfrastructureModule/interfaces/IUnmatchedOrderRepository';

/**
 * 未照合・差異一覧情報を更新するユースケース
 */
export class UpdateUnmatchedOrderUseCase {
  private repository: IUnmatchedOrderRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IUnmatchedOrderRepository) {
    this.repository = repository;
  }

  /**
   * 未照合・差異一覧情報を発注と突合する
   * @param unmatchedOrderId - 未照合発注ID
   * @param targetOrderId - 発注ID
   * @param updateAt - ターゲット発注の更新日時
   * @returns 更新されたID一覧
   */
  public async execute(unmatchedOrderId: string, targetOrderId: string, updateAt: number): Promise<INetworkResult<void, IError>> {
    const networkResult = await this.repository.put({ unmatchedOrderId, targetOrderId, updateAt });
    switch (networkResult.status.type) {
      case 'success':
        return {
          status: {
            type: 'success',
            data: undefined,
          },
        };
      case 'error':
        return { status: { type: 'error', error: networkResult.status.error } };
    }
  }
}
